(async () => {
  const section = document.querySelector(".our-products");
  const swiperEl = document.querySelector(".our-products__swiper");
  const mainContent = document.querySelector(".our-products__main-content");
  const tabsEl = document.querySelector(".js-our-products-tabs");
  const tabLabels = document.querySelectorAll(".js-our-products-tab");
  const cartDrawer = document.querySelector("cart-drawer");
  if (!swiperEl || !mainContent) return;

  section?.addEventListener("submit", (e) => {
    const form = e.target;
    if (form.tagName !== "FORM" || !form.action?.includes("/cart/add")) return;

    const btn = form.querySelector(".our-products__button");
    if (!btn) return;

    e.preventDefault();
    
    if (btn.getAttribute("aria-disabled") === "true") return;
    btn.setAttribute("aria-disabled", "true");
    
    const formData = new FormData(form);
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
      const sectionIds = cartDrawer.getSectionsToRender().map((section) => section.id);
      formData.append("sections", sectionIds.join(","));
      formData.append("sections_url", window.location.pathname);
      cartDrawer.setActiveElement?.(document.activeElement);
    }

    const fetchOptions = typeof fetchConfig === "function" ? fetchConfig("javascript") : { method: "POST"};
    fetchOptions.headers = fetchOptions.headers || {};
    fetchOptions.headers["X-Requested-With"] = "XMLHttpRequest";
    delete fetchOptions.headers["Content-Type"];
    fetchOptions.body = formData;
    const routes = window.routes || {};
    const url = routes.cart_add_url || "/cart/add.js";
    fetch(url, fetchOptions)
      .then((res) => res.json())
      .then((data) => {
        if (data.status){
          if( typeof window.cartStrings !== "undefined" && window.cartStrings?.error ){
            const errEl = section?.querySelector(".our-products__error") || document.getElementById("CartDrawer-CartErrors");
            if (errEl) errEl.textContent = data.description || window.cartStrings.error;
          }
          btn.removeAttribute("aria-disabled");
          return;
        }
        if (cartDrawer && typeof cartDrawer.renderContents === "function" && data.sections){
          cartDrawer.renderContents(data);
        }
        btn.removeAttribute("aria-disabled");
      })
      .catch(()=> {
        btn.removeAttribute("aria-disabled");  
      })
  });

  function setActiveTab(activeTab) {
    if (!section) return;
    const isSubscribe = activeTab === "subscribe";
    section.classList.toggle("our-products--subscribe", isSubscribe);
    tabLabels.forEach((label) => {
      const isSelected = label.dataset.tab === activeTab;
      label.setAttribute("aria-selected", isSelected);
    });
  }

  if (tabsEl && tabLabels.length) {
    tabsEl.addEventListener("click", (e) => {
      const label = e.target.closest(".js-our-products-tab");
      if (label && label.dataset.tab) setActiveTab(label.dataset.tab);
    });
    tabLabels.forEach((label) => {
      label.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          if (label.dataset.tab) setActiveTab(label.dataset.tab);
        }
      });
    });
  }

  document.querySelectorAll(".js-our-products-selling-plan-select").forEach((select) => {
    select.addEventListener("change", () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      const priceEl = select.closest(".our-products__form-subscriptions")?.querySelector(".js-our-products-subscription-price");
      const saveEl = select.closest(".our-products__form-subscriptions")?.querySelector(".js-our-products-subscription-save");
      if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;
      if (saveEl && option.dataset.save) saveEl.textContent = option.dataset.save;
    });
  });

  function updateNavButtonsPosition() {
    const firstSlide = swiperEl.querySelector(".our-products__swiper-slide");
    const topBlock = firstSlide?.querySelector(".our-products__top");
    if (!topBlock) return;

    const mainRect = mainContent.getBoundingClientRect();
    const topRect = topBlock.getBoundingClientRect();
    const centerY = topRect.top - mainRect.top + topRect.height / 2;

    mainContent.style.setProperty("--our-products-nav-top", `${centerY}px`);
  }

  const indexSwiper = new Swiper(".our-products__swiper", {
    slidesPerView: 1.354,
    spaceBetween: 20,
    navigation: {
      nextEl: ".our-products__swiper-button-next",
      prevEl: ".our-products__swiper-button-prev",
    },
    breakpoints: {
      360: {
        slidesPerView: 1.354
      },
      520: {
        slidesPerView: 2.2
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    },
  });

  swiperEl.classList.remove("blur");

  updateNavButtonsPosition();

  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateNavButtonsPosition, 50);
  });
})();
